import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMatic = function SvgMatic(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#7A4ADD"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m76.973 72.66 16.603-9.585A2.86 2.86 0 0 0 95 60.607V41.433a2.86 2.86 0 0 0-1.424-2.468L76.973 29.38a2.86 2.86 0 0 0-2.85 0L57.52 38.966a2.86 2.86 0 0 0-1.424 2.467v34.262l-11.642 6.72-11.643-6.72V62.25l11.642-6.72 7.68 4.432v-9.018l-6.255-3.61a2.86 2.86 0 0 0-2.849 0L26.424 56.92A2.86 2.86 0 0 0 25 59.388V78.56a2.86 2.86 0 0 0 1.424 2.468l16.604 9.587c.878.506 1.969.506 2.849 0L62.48 81.03a2.86 2.86 0 0 0 1.424-2.468V44.3l.21-.12 11.433-6.6L87.189 44.3v13.444l-11.642 6.721-7.669-4.426v9.018l6.244 3.607c.878.506 1.97.506 2.849 0z"
    })));
};

export { SvgMatic as ReactComponent };
//# sourceMappingURL=MATIC.svg.es.js.map
